import { createTheme } from '@mui/material/styles';
import { defaultLightTheme } from 'react-admin';

export const theme = createTheme({
  ...defaultLightTheme,
  palette: {
    primary: {
      main: '#79CF62',
      light: '#ffa464',
      dark: '#275030',
    },
    secondary: {
      main: '#79CF62',
      light: '#ffa464',
      dark: '#275030',
    },
  },
  overrides: {
    MuiPaper: {
      elevation1: {
        boxShadow: 'none',
      },
      root: {
        border: '1px solid #e0e0e3',
        backgroundClip: 'padding-box',
      },
    },
  },
  sidebar: {
    width: 280
  },
  components: {
    ...defaultLightTheme.components,
    RaMenuItemLink: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderLeft: '3px solid #fff',
          // Verde PontuaX (primary.main). Mesmo acento do painel flutuante do
          // submenu (containers/Menu/SubMenu/styles.ts).
          '&.RaMenuItemLink-active': {
            borderLeft: '3px solid #79CF62',
          },
          // Item que o react-admin acendeu só porque a URL COMEÇA com o `to`
          // dele — a URL na verdade pertence a um item mais específico. O
          // `end` do useMatch é fixo dentro do MenuItemLink, então a marcação
          // só pode ser desfeita aqui, no estilo. Quem marca a classe é
          // containers/Menu/MenuItemLink.tsx.
          '&.MenuItemLink-suppressed.RaMenuItemLink-active': {
            borderLeft: '3px solid #fff',
            color: theme.palette.text.secondary,
            fontWeight: theme.typography.fontWeightRegular,
            boxShadow: 'none',
          },
        }),
      },
    },
    RaDatagrid: {
      styleOverrides: {
        root: {
          "& .RaDatagrid-headerCell": {
            backgroundColor: "#7869DF",
            color: '#fff',
          },
          "& .RaDatagrid-rowCellLink": {
            color: '#275030',
            textDecoration: 'none',
            '&:hover': {
              color: '#275030',
              textDecoration: 'underline',
            },
          },
          "& .RaReferenceField-link": {
            color: '#275030 !important',
            textDecoration: 'none',
            '&:hover': {
              color: '#275030',
              textDecoration: 'underline',
            },
          },
          rowCellLink: {
            color: '#275030',
            textDecoration: 'none',
            '&:hover': {
              color: '#275030',
              textDecoration: 'underline',
            },
          },
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: '#e65017'
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#275030',
          '&:hover': {
            color: '#275030',
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          // Target typography inside reference field links
          'a.RaReferenceField-link &': {
            color: '#7869DF !important',
          }
        },
        a: {
          // General anchor styling (if needed)
          color: '#7869DF !important',
          textDecoration: 'none !important',
          '&:hover': {
            textDecoration: 'underline !important'
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          // Target typography inside reference field links
          'a.RaReferenceField-link &': {
            color: '#7869DF !important',
          }
        },
        a: {
          color: '#7869DF !important',
          textDecoration: 'none !important',
          '&:hover': {
            textDecoration: 'underline !important'
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: '#79CF62'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            '& .MuiSvgIcon-root': {
              color: '#275030'
            }
          }
        }
      }
    },
  },
})
